import useDiscard from "../../../../useDiscard";
import { runExtractValue, runUpdatePropValue } from "../../../executor";
import { getTemplateId } from "../../../utils/useTemplateIdentify";
import useMultipleValueSelected from "../../../utils/useMultipleSelection";
import useWatcher, { usePropStore } from "../../useWatcher";
import useAddEvent from "../core/useAddEvent";
import useQueryOriginalSourceByLayer from "../../../../layer/chain/store/useStoreOriginalSource";

const checkbox = (name, props, node) => {

    const { onCreated, onDestroy, onPropChanges } = useWatcher(props, node, [name]);

    let detachEvent;
    const groupName = node.getAttribute('name') ? node.getAttribute('name') : name;
    const { addValue, getValues, removeValue } = useMultipleValueSelected(props, node.getAttribute('name') || name);

    const queryValues = () => runExtractValue(useQueryOriginalSourceByLayer(props), name);

    const bindSelectedByControl = (e) => {
        if (e.target.checked) {
            addValue(e.target.value);
        } else {
            removeValue(e.target.value);
        }
        runUpdatePropValue(props, name, getValues());
    }

    const bindSelectedByProps = () => {
        // console.log("onChanged", props);
        if (!Array.isArray(queryValues())) return;
        const s = new Set(queryValues());
        if (s.has(node.value)) {
            addValue(node.value);
            node.checked = true;
        } else {
            removeValue(node.value);
            node.checked = false;
        }
    }

    const attachEvent = () => {
        detachEvent = useAddEvent(['change'], node, bindSelectedByControl)
    }
    onCreated(() => {
        bindSelectedByProps();
        attachEvent();
    });

    onPropChanges(bindSelectedByProps)

    onDestroy(() => {
        if (typeof detachEvent === 'function') {
            detachEvent();
        }
    })
}

export default checkbox;